import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useIsMobile } from '@sravni/react-utils';

import { useDictionaries } from 'entities/creditForm';

export const EmployerType: FC<IFieldFactoryProps> = (props) => {
  const isMobile = useIsMobile();

  const { employerTypes } = useDictionaries(['employerTypes']);
  const { type, ...other } = props;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={employerTypes}
      withCrossIcon={false}
      mobile={isMobile}
    />
  );
};
